import * as React from 'react';
import { darkAcqa, black70 } from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';
import { PriceIcon } from '../../../components/Icons/PriceIcon';

interface IProps {
    numberOfSails?: number;
}

const HeaderStyle: any = {
    wrapper: {
        margin: '20px 5px 10px',
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    dateSpan: {
        margin: '0',
        fontWeight: 'bold',
    },
    sailsDiv: {
        margin: '0',
        color: black70,
    },
    sailsSpan: {
        margin: '0 5px',
    },
    svg: {
        fill: darkAcqa,
        marginRight: 10,
    },
};
export function PriceHeader(props: IProps) {
    const { numberOfSails } = props;
    const isNumberOfSails = numberOfSails > 1;
    return (
        <div style={HeaderStyle.wrapper}>
            <span style={HeaderStyle.dateSpan}>{__('selectDate', 'dreamlines')}</span>
            {isNumberOfSails && (
                <div style={HeaderStyle.sailsDiv}>
                    <span style={HeaderStyle.sailsSpan}>{numberOfSails}</span>
                    <span>{__('available', 'dreamlines')}</span>
                </div>
            )}
        </div>
    );
}
